import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import { Race } from '../../../../types/race';
import { useEnvAddresses } from '../../../../hooks/useEnvAddresses';

import './RaceHeader.css';
import { formatTokenAmount } from '../../../../utils/formatTokenAmount';

type RaceHeaderProps = {
  race: Race;
};

const RaceHeader = ({ race }: RaceHeaderProps) => {
  const { name, totalPool } = race;
  const { usdc } = useEnvAddresses();
  const [showTooltip, setShowTooltip] = useState(false);

  const handleShare = () => {};

  return (
    <div className="race-headerD">
      <div className="race-header-purple-circle"></div>
      <div className="header-contentD z-10">
        <div className="title-sectionD">
          <div className="title-statusD">
            <h1 className="race-titleD">{name}</h1>
          </div>
        </div>
        <div className="header-actionsD flex flex-col">
          <div className="flex justify-end gap-1">
            <button className="action-buttonD share-buttonD p-2" onClick={handleShare} aria-label="Share race">
              <Share2 size={20} onMouseDown={() => setShowTooltip(true)} onMouseUp={() => setShowTooltip(false)} />
              {showTooltip && <div className="share-tooltipD">{'Share this race'}</div>}
            </button>
          </div>
          <div className="race-infoD flex gap-32">
            <div className="prize-poolD">
              <span className="prize-pool-labelD">Total Staking Reward Pool</span>
              <span className="amountD text-right">${formatTokenAmount(totalPool, usdc.decimals, 'usdc')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RaceHeader;
